//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import PrivacyHeader from '@/components/common/PrivacyHeader'
import { mapGetters } from 'vuex'
import scroll from '@/mixins/scroll'

export default {
  name: 'OfficialInfoPage',
  components: {
    PrivacyHeader,
  },
  mixins: [scroll],
  props: {
    pageId: {
      type: String,
      required: true,
      default: 'general_info',
    },
  },
  data() {
    return {
      pageData: {
        general_info: this.getDefaultData('officialInfoGeneralInfoIsHidden'),
        structure: this.getData(
          'officialInfoStructureIsHidden',
          'officialInfoStructureTitle',
          'officialInfoStructure'
        ),
        documents: this.getData(
          'officialInfoDocumentsIsHidden',
          'officialInfoDocumentsTitle',
          'officialInfoDocuments'
        ),
        education: this.getData(
          'officialInfoEducationIsHidden',
          'officialInfoEducationTitle',
          'officialInfoEducation'
        ),
        requirements: this.getData(
          'officialInfoRequirementsIsHidden',
          'officialInfoRequirementsTitle',
          'officialInfoRequirements'
        ),
        employees: this.getData(
          'officialInfoEmployeesIsHidden',
          'officialInfoEmployeesTitle',
          'officialInfoEmployees'
        ),
        objects: this.getData(
          'officialInfoObjectsIsHidden',
          'officialInfoObjectsTitle',
          'officialInfoObjects'
        ),
        grants: this.getData(
          'officialInfoGrantsIsHidden',
          'officialInfoGrantsTitle',
          'officialInfoGrants'
        ),
        paid_services: this.getData(
          'officialInfoPaidServicesIsHidden',
          'officialInfoPaidServicesTitle',
          'officialInfoPaidServices'
        ),
        finance: this.getData(
          'officialInfoFinanceIsHidden',
          'officialInfoFinanceTitle',
          'officialInfoFinance'
        ),
        vacant: this.getData(
          'officialInfoVacantIsHidden',
          'officialInfoVacantTitle',
          'officialInfoVacant'
        ),
        accessible_environment: this.getData(
          'officialInfoAccessibleEnvironmentIsHidden',
          'officialInfoAccessibleEnvironmentTitle',
          'officialInfoAccessibleEnvironment'
        ),
        international_agreements: this.getData(
          'officialInfoInternationalAgreementsIsHidden',
          'officialInfoInternationalAgreementsTitle',
          'officialInfoInternationalAgreements'
        ),
        additional_1: this.getData(
          'officialInfoAdditional1IsHidden',
          'officialInfoAdditional1Title',
          'officialInfoAdditional1'
        ),
        additional_2: this.getData(
          'officialInfoAdditional2IsHidden',
          'officialInfoAdditional2Title',
          'officialInfoAdditional2'
        ),
      },
    }
  },
  computed: {
    ...mapGetters({
      currentLanguageCode: 'landings/currentLanguageCode',
    }),
    visibleSections() {
      const sections = []
      for (const section in this.pageData) {
        if (this.pageData[section].visible === true) {
          const item = this.pageData[section]
          item.key = section
          sections.push(item)
        }
      }
      return sections
    },
  },
  methods: {
    getData(isHiddenKey, titleKey, textKey) {
      if (this.$getTextSetting(isHiddenKey)) {
        return this.getDefaultData(isHiddenKey)
      }

      return {
        title: this.$getTextSetting(titleKey),
        text: this.$getTextSetting(textKey),
        visible: true,
      }
    },
    getDefaultData(isHiddenKey) {
      return {
        title: this.$getTextSetting('officialInfoGeneralInfoTitle'),
        text: this.$getTextSetting('officialInfoGeneralInfo'),
        visible: !this.$getTextSetting(isHiddenKey),
      }
    },
    getText() {
      return this.pageData[this.pageId]?.text
        ? this.pageData[this.pageId]?.text
        : this.pageData.general_info?.text
    },
    getTitle() {
      return this.pageData[this.pageId]?.title
        ? this.pageData[this.pageId]?.title
        : this.pageData.general_info.title
    },
    currentLanguage() {
      return this.currentLanguageCode.substring(0, 2)
    },
    changePageId(url) {
      this.$nuxt.$emit('change-page', url)
    },
  },
}
